import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { INFERENCE_STATUSES, InferenceStatus, UserPolices } from "constant";
import usePolicy from "hooks/usePolicy";

import IconButton from "components/buttons/IconButton/IconButton";
import InferenceAction from "components/InferenceAction/InferenceAction";
import InferenceStatusComponent from "components/InferenceStatusComponent/InferenceStatusComponent";
import ShowHideButton from "components/buttons/ShowHideButton/ShowHideButton";

import DragHandleDotsIcon from "assets/icons/drag-handle-dots.svg";
import TrashIcon from "assets/icons/trash.svg";
import EyeCloseGrayIcon from "assets/icons/eye-close-gray.svg";
import EyeOpenGrayIcon from "assets/icons/eye-open-gray.svg";
import MarkersFlagOff from "assets/icons/markers-flag-off.svg";
import MarkersFlagOn from "assets/icons/markers-flag.svg";

import styles from "./provider-file-manager-modal.module.scss";

const SortableItem = ({
  item,
  onUpdateVisibilityProvidersMarkers,
  onUpdateVisibilityProvidersTiles,
  inferenceDurationTime,
  uploadDurationTime,
  onDelete,
  id,
  alias
}) => {
  const { hasPolicy } = usePolicy();

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles["providers-table__body"]}
    >
      <div className={styles["drag-dots"]}>
        <img
          src={DragHandleDotsIcon}
          alt="drag-dots"
          {...attributes}
          {...listeners}
          style={{ cursor: "grab" }}
        />
        <ShowHideButton
          onClick={onUpdateVisibilityProvidersTiles(item)}
          isActive={item.isActiveTiles}
          enabledIcon={EyeOpenGrayIcon}
          disabledIcon={EyeCloseGrayIcon}
        />
        <ShowHideButton
          onClick={onUpdateVisibilityProvidersMarkers(item)}
          isActive={item.isActiveMarkers}
          enabledIcon={MarkersFlagOn}
          disabledIcon={MarkersFlagOff}
        />
      </div>
      <div className={styles["name"]}>{item.data.name}</div>
      {hasPolicy(UserPolices.PROJECT_PROVIDER_DELETE) && (
        <IconButton
          onClick={onDelete(item.id)}
          icon={TrashIcon}
          alt="trash-icon"
          disabled={item.isDeleteProviderLoading}
          isLoading={item.isDeleteProviderLoading}
        />
      )}
      <div className={styles["name"]}>{uploadDurationTime(item.inference)}</div>

      {item?.inference?.status ? (
        <InferenceAction
          id={id}
          providerId={item.id}
          alias={alias}
          status={INFERENCE_STATUSES[item?.inference?.status]}
          isLoading={item.isInferenceStatusWaiting}
          disabled={item.isDeleteProviderLoading}
        />
      ) : (
        <div className={styles["name"]}>File upload error</div>
      )}
      <div className={styles["name"]}>
        {inferenceDurationTime(item.inference)}
      </div>
      <InferenceStatusComponent
        status={INFERENCE_STATUSES[item?.inference?.status]}
        completionPercentage={
          item?.inference?.status === InferenceStatus.PROCESSING
            ? item?.inference?.data?.completion_percentage
            : item?.inference?.fileUploadData
            ? item?.inference?.fileUploadData.progress
            : undefined
        }
      />
    </div>
  );
};

export default SortableItem;
